import './App.css';
import Front from './comp/front';

function App() {
  return (
    <div className="App">
      <Front/>
      
    </div>
  );
}

export default App;
